import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const parseServerDateToLocal = (epoch) => {
  if (epoch == null || epoch === "") return null;
  const parsed =
    typeof epoch === "string"
      ? (() => {
          const raw = String(epoch).trim();
          const hasTimezoneInfo = /([zZ]|[+-]\d{2}:?\d{2}|GMT|UTC)$/i.test(raw);
          return hasTimezoneInfo ? dayjs.utc(raw) : dayjs.utc(`${raw}Z`);
        })()
      : dayjs.unix(Number(epoch));
  if (!parsed.isValid()) return null;
  return parsed.local();
};

export const userBaseURL = process.env.REACT_APP_USER_BASE_URL || "";
export const userBaseURLV2 =
  process.env.REACT_APP_USER_BASE_URL_V2 ||
  (userBaseURL ? userBaseURL.replace(/\/v1\/?$/, "/v2") : "");
export const trainingBaseURL = process.env.REACT_APP_TRAINING_BASE_URL || "";
export const trainingBaseURLV2 =
  process.env.REACT_APP_TRAINING_BASE_URL_V2 ||
  (trainingBaseURL ? trainingBaseURL.replace(/\/v1\/?$/, "/v2") : "");
export const testBaseURL = process.env.REACT_APP_TEST_BASE_URL || "";
export const testBaseURLV2 =
  process.env.REACT_APP_TEST_BASE_URL_V2 ||
  (testBaseURL ? testBaseURL.replace(/\/v1\/?$/, "/v2") : "");
export const notificationBaseURL = process.env.REACT_APP_NOTIFICATION_BASE_URL || "";
export const tiktokClientKey = process.env.REACT_APP_TIKTOK_CLIENT_KEY || "";
export const reactAppSecKey = process.env.REACT_APP_SEC_KEY || "";

/** Required env vars for the app. Used for validation and dev-tool logging only; app does not crash when missing. */
export const requiredEnvVars = [
  "REACT_APP_USER_BASE_URL",
  "REACT_APP_TRAINING_BASE_URL",
  "REACT_APP_TRAINING_BASE_URL_V2",
  "REACT_APP_TEST_BASE_URL",
  "REACT_APP_NOTIFICATION_BASE_URL",
  "REACT_APP_SEC_KEY",
  "REACT_APP_TIKTOK_CLIENT_KEY",
];

/**
 * Returns list of required env var names that are missing or empty. Use to show a toast and log in console; do not block app load.
 * @returns {string[]}
 */
export function getMissingRequiredEnvVars() {
  return requiredEnvVars.filter(
    (name) => !process.env[name] || String(process.env[name]).trim() === ""
  );
}

/**
 * Returns the encryption key if set, or null. Use where missing key should not crash (e.g. app load, axios).
 * @returns {string|null}
 */
export function getEncryptionKeyIfSet() {
  const key = reactAppSecKey;
  if (key == null || String(key).trim() === "") return null;
  return String(key).trim();
}

/**
 * Returns the encryption key for CryptoJS AES. Throws if missing. Use when key is required (e.g. login encrypt).
 * @returns {string}
 * @throws {Error} If REACT_APP_SEC_KEY is missing or empty in .env
 */
export function getEncryptionKey() {
  const key = getEncryptionKeyIfSet();
  if (key == null) {
    throw new Error(
      "Encryption key is missing. Please contact support."
    );
  }
  return key;
}

export const getDateWithoutDay = (epoch) => {
  const parsed = parseServerDateToLocal(epoch);
  return parsed ? parsed.format("MMM D, YYYY") : "N/A";
};
export const getDate = (epoch) => {
  const parsed = parseServerDateToLocal(epoch);
  return parsed ? parsed.format("ddd. MMMM D, YYYY") : "N/A";
};
export const getDateWithTime = (epoch) => {
  const parsed = parseServerDateToLocal(epoch);
  return parsed ? parsed.format("ddd. MMM D, YYYY @ h:mm A") : "N/A";
};

export const getDateWithTimeWithoutDay = (epoch) => {
  const parsed = parseServerDateToLocal(epoch);
  return parsed ? parsed.format("MMM D, YYYY @ h:mm A") : "N/A";
};

export const getDateWithoutMonth = (epoch) => {
  const parsed = parseServerDateToLocal(epoch);
  return parsed ? parsed.format("ddd D, YYYY h:mm A") : "N/A";
};
export const getTime = (epoch) => {
  const parsed = parseServerDateToLocal(epoch);
  return parsed ? parsed.format("h:mm A") : "N/A";
};
export const graphDate = (epoch) => {
  const parsed = parseServerDateToLocal(epoch);
  return parsed ? parsed.format("DD/MM/YY") : "N/A";
};

export const secondsToTime = (e) => {
  const h = Math.floor(e / 3600)
      .toString()
      .padStart(2, "0"),
    m = Math.floor((e % 3600) / 60)
      .toString()
      .padStart(2, "0"),
    s = Math.floor(e % 60)
      .toString()
      .padStart(2, "0");

  return h + ":" + m + ":" + s;
};
export const convertSeconds = (sec) => {
  const minutes = Math.floor((sec % 3600) / 60);
  const seconds = sec % 60;
  if (minutes > 0 && seconds > 0) {
    return `${minutes} min  ${seconds} sec`;
  } else if (minutes > 0 && seconds <= 0) {
    return `${minutes} min`;
  } else if (seconds > 0) {
    return `${seconds} sec`;
  }
};
